import React from "react";

import GroupInformation from "./groupInformation/groupInformation";
import ProfileInformation from "../../../../common/profileInformation/profileInformation";
import { CONFIGURATION } from "utilities/configuration";

export default function CreateQuoteStepOne(props) {
    const { data, events, errors } = props;
    const { quote, currentStep, groupTypes, groupEventAvailable } = data;

    if (currentStep !== CONFIGURATION.QUOTE_WIZARD_STEP_GROUP_INFO) {
        return null;
    }

    return (
        <div className="row">
            <ProfileInformation handleStep1Data={events.handleStep1Data} quote={quote} isHomePage={props.isHomePage} isOnStepOne={true}/>
            <GroupInformation
                groupTypes={groupTypes}
                quote={quote}
                errors={errors}
                handleStep1Data={events.handleStep1Data}
                groupEventAvailable={groupEventAvailable}
            ></GroupInformation>
        </div>
    );
}
